import { ScrollTop } from '@/components/element/ScrollTop';
import { Activities } from '@/components/features/tasks/quotation/Activities';
import { Comments } from '@/components/features/tasks/quotation/Comments';
import { ProjectInfo } from '@/components/features/tasks/quotation/ProjectInfo';
import { TaskFiles } from '@/components/features/tasks/quotation/TaskFiles';
import { TaskProgress } from '@/components/features/tasks/quotation/TaskProgress';
import { TaskSummary } from '@/components/features/tasks/quotation/TaskSummary';
import { ToDoList } from '@/components/features/tasks/quotation/ToDoList';
import { WorkspaceLayout } from '@/components/layout/WorkspaceLayout';
import { useNavState } from '@/providers/NavStateProvider';
import { useCurrentWorkspace } from '@/providers/WorkspaceProvider';
import { useEffect } from 'react';

export const BackofficeQuotationTask = () => {
  const { setTitle, setBreadcrumbs } = useNavState();
  const { _w_ } = useCurrentWorkspace();
  useEffect(() => setTitle('見積申請タスク詳細'), []);
  useEffect(
    () => setBreadcrumbs([{ label: `見積申請タスク一覧`, path: `/w/${_w_!.identifier}/backoffice/quotation_tasks` }]),
    []
  );

  return (
    <WorkspaceLayout>
      <ScrollTop />

      <div className="container-fluid py-4">
        <div className="row mb-4">
          <div className="col-12 col-lg-7">
            <ToDoList />

            <TaskFiles />

            <Comments />
          </div>
          <div className="col-12 col-lg-5">
            <TaskSummary />

            <TaskProgress />

            <ProjectInfo />

            <Activities />
          </div>
        </div>
      </div>
    </WorkspaceLayout>
  );
};
